<template>
  <div class="text-2xl font-semibold leading-[150%]">
    <slot></slot>
  </div>
</template>

<script setup lang="ts"></script>
